import bizTable from '@/biz/bizTable.mjs'

export default bizTable('/basdatadictdtls?dictCode=UC_PRIORITY', 'code')
